<div class="text-center mt-50">
    <div class="spinner-border" style="color:#105F96" role="status">
    </div>
  </div>